export default __webpack_public_path__ + "static/side-nav-do-2-7c5106d2a7912acf17005e86c0ab5a2a834ad1ba26504e35be1725c599bd3b83.png";